import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { IMSplitDirection } from './typings';

export const defaultSize = { area1: 50, area2: 50 };

@Injectable()
export class MSplitLayoutService {
  direction$ = new Subject<IMSplitDirection>();
  leftArea$ = new BehaviorSubject<number>(defaultSize.area1);
  rightArea$ = new BehaviorSubject<number>(defaultSize.area2);
}
